<template>
  <config-pro-plus-base
    class="opc-zone-bundle__main-add"
    :show-full-comparison-dialog="showFullComparisonDialog"
    show-plan-details>
    <template #config>
      <div class="opc-zone-bundle__main-add-title">
        <p class="label-title-1">
          {{ $t('billing.zone_pro_plus.select_local_number_title') }}
          <zm-tooltip
            slot="label-suffix"
            :content="$t('billing.zone.attendee_info')"
            aria-label="Learn more about numbers"
            placement="top"
          >
            <zm-button data-testid="checkout-button-120" ghost icon="zm-icon-info-outline main-color-icon" size="mini" type="icon"></zm-button>
          </zm-tooltip>
        </p>
        <p class="label-desc-1">
          <span>{{ $t('billing.zone_pro_plus.select_local_number_desc') }}</span>
        </p>
      </div>
      <template>
        <add-config v-if="boughtPbxBasePlan" :min-hosts="minHosts" :decrease-tips="decreaseTips" @license-change="onLicenseChange" />
        <config-plan v-else :min-hosts="minHosts" />
        <div v-show="showContinueWithLargeMeetingPromotion" class="opc-zone-bundle__lm-promotion" v-html="$t('billing.zoom_one_biz.continue_with_lm')"></div>
      </template>
    </template>
  </config-pro-plus-base>
</template>

<script type="text/jsx">
import query from 'query-string';
import ConfigProPlusBase from '@/plans/ZONE_PRO_PLUS/component/config-base';
import { mapGetters } from 'vuex';
import AddConfig from '@/plans/ZONE_PRO_PLUS/config/add-config.vue';
import ConfigPlan from '@/plans/ZONE_PRO_PLUS/config/config-plan';
import ConfigMixin from '@/plans/ZONE_PRO_PLUS/mixin/config-mixin';
import _ from 'lodash';
import { planTypes } from '@/common/constants';

export default {
  mixins: [ConfigMixin],
  components: { AddConfig, ConfigProPlusBase, ConfigPlan },
  data() {
    return {
      decreaseTips: ''
    }
  },
  computed: {
    ...mapGetters([
      'boughtPbxBasePlan', 
      'boughtPlans',
      'getUserCurrentSubscriptions',
      'limitLicenseWithBaseZoneTypes',
      'draftPlanFilterKeys',
    ]),
    minHostAndReason() {
      let result = {
        minHosts: 1,
        reason: ''
      }
      const maxAssignLicensePlan = this.getUserCurrentSubscriptions
        .filter(item => _.includes(this.limitLicenseWithBaseZoneTypes, item.type))
        .reduce((maxPlan, plan) => {
          if (!maxPlan) return plan
          if (plan?.cartInfo?.selected_number > (maxPlan?.cartInfo?.selected_number || 0)) {
            return plan;
          }
          return maxPlan;
        }, undefined);
      if (maxAssignLicensePlan?.cartInfo?.selected_number > 1) {
        result = {
          minHosts: maxAssignLicensePlan?.cartInfo?.selected_number,
          reason: this.$t('billing.licences_limit_tips', [this.$t(maxAssignLicensePlan.planNameKey), this.$t('billing.zone_pro_plus.title')])
        }
      }
      return result
    },
    minHosts() {
      return this.minHostAndReason.minHosts
    },
    showPlanDetails() {
      return true;
    },
    showContinueWithLargeMeetingPromotion() {
      const isInRetentionFlow = query.parse(location.search).retention === 'downgrade'
      return !_.some(this.boughtPlans, (plan) => plan.type === planTypes.LARGE_MEETING) &&
      !_.some(this.draftPlanFilterKeys, (key) => key === 'LARGE_MEETING') &&
      !window.newBillingConfig?.hasPendingEventOfLM === true &&
      isInRetentionFlow
    }
  },
  methods: {
    handleAddLargeMeeting() {
      this.$emit('add', 'LARGE_MEETING')
    },
    onLicenseChange(val) {
      if (val <= this.minHosts && val > 1) {
        this.decreaseTips = this.minHostAndReason.reason
      } else {
        this.decreaseTips = ''
      }
    }
  },
  mounted() {
    const btn = this.$el.querySelector('.opc-zone-bundle__lm-promotion a')
    if (btn) {
      btn.addEventListener('click', this.handleAddLargeMeeting.bind(this))
      btn.setAttribute('role', 'button')
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-zone-bundle__main-add {
    &-title {
      margin-bottom: 8px;

      .label-title-1 {
        font-size: 18px;
        font-weight: 700;
        line-height: 27px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 8px;
      }

      .label-desc-1 {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        text-align: left;
      }
    }

    .main-color-icon {
      font-size: 14px;
      color: $theme-color;
    }
    .opc-zone-bundle__lm-promotion {
      background: #DBF9F9;
      border-radius: 8px;
      padding: 8px 12px 8px 12px;
      margin-top: 20px;
      a {
        color: #0B5CFF;
      }
    }
}
</style>
